import type { OrderTask } from '@my/tms-api';

/**
 * The task a "next point" is: the first stop still to do (Pending or In
 * progress) in execution order. Undefined once every stop is done — the
 * screens say "All tasks done" then. Shared by Orders and Plan.
 */
export function nextPointTask(tasks: OrderTask[]): OrderTask | undefined {
  return tasks.find((t) => t.state === 'Pending' || t.state === 'InProgress');
}
